import React from 'react';
import Form from 'react-bootstrap/Form';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import { Container, Row, Button, Col, Spinner } from 'react-bootstrap';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import { withAuthorization } from '../Session';

const columns = [
    { title: 'From', field: 'From' },
    { title: 'To', field: 'To' },
    { title: 'UserType', field: 'UserType' },
    { title: 'On Date', field: 'Date' },
    { title: 'Mapped By', field: 'UpdatedBy' }
];

class MappingHistory extends React.Component {
    _isMounted = false;
    state = {
        showSpinner: false,
        alert: 0,
        StoreTag: '',
        userType: '',
        alertMessage: '',
        flag: false,
        showTable: false,
        serveroptions: [],
        data: [],
        allUserType: ['Distributor', 'StoreOwners', 'Employee', 'StoreCP']
    };

    async componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async searchStoreTag(search_key) {
        if (this._isMounted) {
            this.setState({ StoreTag: search_key });
        }
        let bodyData = {
            search_key: search_key,
            search_by: 'StoreTag',
            UniqeID: this.props.user.ProfileUniqeID,
            userRole:
                this.props.role == 'StoreOwners'
                    ? 'StoreOwner'
                    : this.props.role,
            perPage: 10
        };
        await RestServices.SearchStoreTagsMapping(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (StoreTags) => {
                if (this._isMounted) {
                    this.setState({ serveroptions: StoreTags.list });
                }
            })
            .catch((err) => {});
    }

    async SubmitFormData() {
        let data = {
            StoreTag: this.state.StoreTag
        };
        
        await RestServices.getStoreTagMappingHistory(
            localStorage.getItem('FirebaseToken'),
            data
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData) {
                    if (responseData.error) {
                        if (this._isMounted) {
                            this.setState({
                                flag: false,
                                alert: 1,
                                alertMessage: responseData.error
                            });
                        }
                    } else {
                        if (this._isMounted) {
                            this.setState({
                                data: responseData,
                                flag: false,
                                alert: 0,
                                showTable: true
                            });
                        }
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({
                            data: [],
                            flag: false,
                            alert: 0,
                            showTable: true
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    render() {
        return (
            <Container>
                {this.state.showSpinner && <Spinner animation="border" />}
                <Row>
                    <h4 style={{ marginLeft: '1rem', marginRight: '1rem' }}>
                        Manage Store Tags Mapping History
                    </h4>
                </Row>
                <div>
                    <hr />
                </div>

                <Row>
                    <Col>
                        <Autocomplete
                            name="storeTag"
                            onInputChange={(event, newInputValue) => {
                                if (newInputValue.length > 1) {
                                    this.searchStoreTag(newInputValue);
                                }
                            }}
                            options={this.state.serveroptions.map((arr) => arr)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Store Tag"
                                    margin="normal"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Col>

                    <Col>
                        <Button
                            style={{ marginTop: '1.5rem' }}
                            variant="primary"
                            type="submit"
                            onClick={() => {
                                this.SubmitFormData();
                            }}
                        >
                            Submit
                        </Button>
                    </Col>
                </Row>

                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.showTable && (
                    <MaterialTable
                        components={{
                            Pagination: PatchedPagination
                        }}
                        title="Mapping History"
                        columns={columns}
                        data={this.state.data}
                        options={{
                            actionsColumnIndex: -1,
                            selection: false,
                            exportButton: true,
                            showFirstLastPageButtons: true,
                            pageSize: 15,
                            pageSizeOptions: [15, 25, 50, 100]
                        }}
                    />
                )}
            </Container>
        );
    }
}
const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(MappingHistory);
